import { useLoading } from '../../contexts/LoadingContext';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useCollabReportDeleteMutation = (onError: (errorMessage: string) => void) => {
    const loading = useLoading();
    const { zoneApiClient } = useZoneContext();
    return useMutation({
        mutationFn: async (reportGuid:string) => {
            loading.showLoading();

            const response = await zoneApiClient.deleteCollaborationReport(reportGuid);

            if (!response?.httpResponse.ok) {
                throw new Error('Failed to delete Collab Report');
            }

            return response;
        },
        onError(error) {
            if (error instanceof Error) {
                onError(error.message);
            }
        },
        onSettled: () => loading.hideLoading(),
    });
};
